import _ from 'lodash';

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const routes = [
  {
    path: 'accessoriesProcurement',
    name: 'accessoriesProcurement',
    meta: {
      title: '辅料采购',
    },
    component: _import('procurement/accessoriesProcurement.vue'),
  },
  {
    path: 'fabricProcurement',
    name: 'fabricProcurement',
    meta: {
      title: '面料采购',
    },
    component: _import('procurement/fabricProcurement.vue'),
  },
];

export default _.map(routes, r => ({
  ...r,
  path: `procurement/${r.path}`,
  meta: _.defaults({
    auth: true,
  }, r.meta),
}));
